export class EditGroupRemoveDumpstersInput {
  groupId: number;
  dumpsters: number[];

  constructor(groupId: number, dumpsters: number[]) {
    this.groupId = groupId;
    this.dumpsters = dumpsters;
  }
}
